module.exports = __webpack_public_path__ + "media/11.470e0586.mp3";